<div class="mbs-wizard_form">
  <div class="mbs-wizard_form-content">
    <mbs-form-group [formGroup]="stepForm">
      <ng-container *ngTemplateOutlet="noScheduleAlert"></ng-container>
      <ng-container *ngTemplateOutlet="simpleInfo"></ng-container>
      <ng-container *ngTemplateOutlet="advancedInfo"></ng-container>
      <ng-container *ngTemplateOutlet="simpleBlock"></ng-container>
      <ng-container *ngTemplateOutlet="advancedBlock"></ng-container>

      <ng-template #noScheduleAlert>
        <div *ngIf="schedule.isManual"
             [id]="elementSelectors.id.notScheduleAlert">
          <mbs-alert [type]="mbsPopupType.warning"
                     [icon]="true">
            {{'wizards:retention_policy_not_full_alert' | i18next}}
          </mbs-alert>
        </div>
      </ng-template>

      <ng-template #simpleInfo>
        <div *ngIf="schedule.isSimple"
             [id]="elementSelectors.id.simpleInfo">
          <mbs-card [size]="'xs'">
            <div class="row ml-n1">
              <div class="col-11">
                <strong class="d-flex align-items-center">{{ 'wizards:schedule.simpleMode.backupSchedule' | i18next }}</strong>
                <div class="d-flex align-items-center">{{ schedule.scheduleInfo.simple }}</div>
              </div>
              <div class="col-auto d-flex align-items-center">
                <ng-container *ngTemplateOutlet="infoTooltip"></ng-container>
              </div>
            </div>
          </mbs-card>
        </div>
      </ng-template>

      <ng-template #advancedInfo>
        <div *ngIf="schedule.isAdvanced"
             [id]="elementSelectors.id.advancedInfo">
          <mbs-card [size]="'xs'">
            <div class="row ml-n1">
              <div class="col-11">
                <strong class="d-flex align-items-center">{{ 'wizards:schedule.advancedMode.incrementalBackupSchedule' | i18next }}</strong>
                <div *ngIf="schedule.incrementalDataEnabled"
                     class="d-flex align-items-center"
                     [id]="elementSelectors.id.advancedInfoIncrementalSchedule">
                  {{ schedule.scheduleInfo.incremental }}
                </div>
                <div *ngIf="!schedule.incrementalDataEnabled"
                     class="d-flex align-items-center"
                     [id]="elementSelectors.id.advancedInfoNoIncrementalSchedule">
                  {{ 'wizards:retention.advancedSchedule.disabledIncremental' | i18next }}
                </div>
                <strong class="d-flex align-items-center mt-2">{{ 'wizards:schedule.advancedMode.fullBackupSchedule' | i18next }}</strong>
                <div class="d-flex align-items-center">{{ schedule.scheduleInfo.full }}</div>
              </div>
              <div class="col-auto d-flex align-items-center">
                <ng-container *ngTemplateOutlet="infoTooltip"></ng-container>
              </div>
            </div>
          </mbs-card>
        </div>
      </ng-template>

      <ng-template #simpleBlock>
        <div *ngIf="schedule.isSimple || schedule.isManual"
             [id]="elementSelectors.id.simpleBlock">
          <mbs-card [size]="'xs'"
                    class="mt-3">
            <ng-container *ngTemplateOutlet="retentionPeriod"></ng-container>
          </mbs-card>
        </div>
      </ng-template>

      <ng-template #advancedBlock>
        <div *ngIf="schedule.isAdvanced"
             [id]="elementSelectors.id.advancedBlock">
          <mbs-card [size]="'xs'"
                    class="mt-3">
            <mbs-card-group>
              <ng-container *ngTemplateOutlet="retentionPeriod"></ng-container>
            </mbs-card-group>
            <mbs-card-group>
              <div class="row ml-n1">
                <div class="col-11">
                  <div class="d-flex align-items-center">
                    <strong class="ml-0"
                            [class.text-muted]="stepForm.get('RetentionUseDefaultSettings').value">
                      {{ 'wizards:retention.advancedSchedule.titleGFS' | i18next }}
                    </strong>
                    <span class="fa fa-info-circle ml-2 cursor-help text-info"
                          container="body"
                          tooltipClass="tooltip-xl"
                          [placement]="'right'"
                          [ngbTooltip]="'wizards:retention.advancedSchedule.titleGFSTooltip' | i18next"></span>
                  </div>
                  <mbs-button class="m-0 _hover-parent"
                              type="link"
                              [customClasses]="'pl-0'"
                              [disabled]="stepForm.get('RetentionUseDefaultSettings').value || !stepForm.get('GFSPolicySettings').get('enabled').value"
                              [id]="elementSelectors.id.buttonGFS"
                              (click)="clickDetailsGFS()">
                    <div class="col-auto mt-1">
                      <div *ngFor="let info of GFSInfo; let i = index"
                           class="d-flex align-items-center">
                        {{ info }}
                        <span *ngIf="!i"
                              class="_hover-target fa fa-pencil ml-2 mt-1"></span>
                      </div>
                      <div *ngIf="!GFSInfo"
                           class="d-flex align-items-center">{{ 'shared:common.disabled' | i18next: { format: 'title' } }}</div>
                    </div>
                  </mbs-button>
                </div>
                <div class="col-1 d-flex align-items-center">
                  <mbs-switcher [selected]="stepForm.get('GFSPolicySettings').get('enabled').value"
                                [disabledSelf]="stepForm.get('RetentionUseDefaultSettings').value"
                                [id]="elementSelectors.id.switcherGFS"
                                (change)="GFSEnabledChangeHandler()">
                  </mbs-switcher>
                </div>
              </div>
            </mbs-card-group>
          </mbs-card>
        </div>
      </ng-template>

      <ng-template #infoTooltip>
        <span class="fa fa-info-circle ml-2 cursor-help text-info"
              container="body"
              tooltipClass="tooltip-lg"
              closeDelay="1000"
              [ngbTooltip]="simpleInfoTooltip"></span>
        <ng-template #simpleInfoTooltip>
          {{ 'wizards:retention.infoTooltip' | i18next }}.&nbsp;
          <a *ngIf="ability.can('read', 'HelpMarketing')"
             class="ml-2"
             href="/AP/Help/backup/file/nbf#9"
             target="_blank">
            {{'shared:buttons.learnMore' | i18next}}
          </a>
        </ng-template>
      </ng-template>

      <ng-template #retentionPeriod>
        <div class="row justify-content-between ml-n1">
          <div class="col-auto flex-grow-1">
            <div class="d-flex align-items-center m-0 mb-2">
              <strong>{{ 'wizards:retention.retentionPeriod' | i18next }}</strong>
              <span *ngIf="schedule.isSimple || schedule.isAdvanced"
                    class="fa fa-info-circle ml-2 cursor-help text-info"
                    container="body"
                    tooltipClass="tooltip-xl"
                    [placement]="'right'"
                    [ngbTooltip]="retentionPeriodTooltip"></span>
              <ng-template #retentionPeriodTooltip>
                <div *ngIf="schedule.isSimple">{{ 'wizards:retention.simpleSchedule.retentionPeriodTooltip' | i18next }}</div>
                <div *ngIf="schedule.isAdvanced">{{ 'wizards:retention.advancedSchedule.retentionPeriodTooltip' | i18next }}</div>
              </ng-template>
            </div>
            <div class="form-row align-items-center ml-n1">
              <div class="col-2">
                <mbs-number formControlName="deleteVersionsOlderThanCount"
                            min="1"
                            [id]="elementSelectors.id.simpleBlockCount"
                            (change)="retentionChangeHandler()"></mbs-number>
              </div>
              <div class="col-3">
                <mbs-select formControlName="deleteVersionsOlderThanPeriod"
                            [appendTo]="'.modal-content'"
                            [bindValue]="'value'"
                            [bindLabel]="'label'"
                            [clearable]="false"
                            [items]="periodEnumSelectArray"
                            [id]="elementSelectors.id.simpleBlockPeriod"
                            [searchable]="false"
                            (change)="retentionChangeHandler()"></mbs-select>
              </div>
            </div>
          </div>
          <div class="col-auto d-flex align-items-center">
            <mbs-switcher *ngIf="!schedule.isSimple"
                          [selected]="!stepForm.get('RetentionUseDefaultSettings').value"
                          [attr.data-test-element]="elementSelectors.id.simpleBlockSwitcher"
                          (change)="retentionUseDefaultSettingsChangeHandler()">
            </mbs-switcher>
          </div>
        </div>
        <div class="d-flex align-items-center m-0 mt-1">
          <mbs-input-errors *ngIf="schedule.isSimple"
                            [errors]="[{ message: keepBackupFFIAlert }]"></mbs-input-errors>
        </div>
        <div *ngIf="!intelligentRetention && needMinPeriodAlert"
             class="d-flex align-items-center m-0 mt-4"
             [id]="elementSelectors.id.simpleBlockMinPeriodNotIRAlert">
          <mbs-alert class="mb-0"
                     [type]="!schedule?.isAdvanced ? mbsPopupType.danger : mbsPopupType.info"
                     [icon]="true">
            <strong *ngIf="!schedule?.isAdvanced">
              {{ 'wizards:retention.simpleSchedule.minPeriodNotIRAlertTitle' | i18next: { name: storage.name } }}
            </strong>
            <div [class.mt-1]="!schedule?.isAdvanced">
              {{ 'wizards:retention.simpleSchedule.minPeriodNotIRAlert' | i18next: { name: storage.name, minPeriod: storage.minPeriod } }}.&nbsp;
              <a *ngIf="ability.can('read', 'HelpMarketing')"
                 class="ml-2"
                 href="/AP/Help/backup/about/retention-policy"
                 target="_blank">
                {{'shared:buttons.learnMore' | i18next}}
              </a>
            </div>
          </mbs-alert>
        </div>
        <div *ngIf="intelligentRetention && needMinPeriodAlert && !schedule.isManual"
             class="d-flex align-items-center m-0 mt-4"
             [id]="elementSelectors.id.simpleBlockMinPeriodAlert">
          <mbs-alert class="mb-0"
                     [type]="mbsPopupType.info"
                     [icon]="true">
            <strong *ngIf="!schedule?.isAdvanced">
              {{ 'wizards:retention.simpleSchedule.minPeriodAlertTitle' | i18next: { name: storage.name } }}
            </strong>
            <div [class.mt-1]="!schedule?.isAdvanced">
              {{
                schedule?.isAdvanced
                  ? ('wizards:retention.advancedSchedule.minPeriodAdvancedAlert' | i18next: { minPeriod: storage.minPeriod })
                  : 'wizards:retention.simpleSchedule.minPeriodAlert' | i18next: { name: storage.name, minPeriod: storage.minPeriod } }}.&nbsp;
              <a *ngIf="ability.can('read', 'HelpMarketing')"
                 class="ml-2"
                 href="/AP/Help/backup/about/retention-policy"
                 target="_blank">
                {{'shared:buttons.learnMore' | i18next}}
              </a>
            </div>
          </mbs-alert>
        </div>
        <div *ngIf="stepForm.get('RetentionUseDefaultSettings').value && !needRetentionForGFSAlert"
             class="d-flex align-items-center m-0 mt-4"
             [id]="elementSelectors.id.simpleBlockRecommendTurnOn">
          <mbs-alert class="mb-0"
                     [type]="mbsPopupType.danger"
                     [icon]="true">
            <div>
              {{ 'wizards:retention.simpleSchedule.recommendTurnOn' | i18next }}
              <a *ngIf="ability.can('read', 'HelpMarketing')"
                 class="ml-2"
                 href="/AP/Help/backup/about/retention-policy"
                 target="_blank">
                {{'shared:buttons.learnMore' | i18next}}
              </a>
            </div>
          </mbs-alert>
        </div>
        <div *ngIf="!stepForm.get('RetentionUseDefaultSettings').value && keepBackupFullAlert"
             class="d-flex align-items-center m-0 mt-4"
             [id]="elementSelectors.id.advancedBlockMinPeriodAlert">
          <mbs-alert class="mb-0"
                     [type]="mbsPopupType.warning"
                     [icon]="true">
            <div class="mb-2">{{ 'wizards:retention.advancedSchedule.minPeriodAlertP1' | i18next }}</div>
            <div>{{ 'wizards:retention.advancedSchedule.minPeriodAlertP2' | i18next }}</div>
            <div>
              <a *ngIf="ability.can('read', 'HelpMarketing')"
                 href="/AP/Help/backup/file/nbf#9"
                 target="_blank">
                {{'shared:buttons.learnMore' | i18next}}
              </a>
            </div>
          </mbs-alert>
        </div>

        <div *ngIf="!keepBackupFullAlert && schedule.isAdvanced"
             class="d-flex align-items-center m-0 mt-4"
             [id]="elementSelectors.id.advancedInfoAlert">
          <mbs-alert class="mb-0"
                     [type]="mbsPopupType.info"
                     [icon]="true">
            {{ 'wizards:retention.advancedSchedule.retentionPeriodMisconfiguration' | i18next }}
            <a *ngIf="ability.can('read', 'HelpMarketing')"
               href="/AP/Help/backup/about/retention-policy"
               target="_blank">
              {{'shared:buttons.learnMore' | i18next}}
            </a>
          </mbs-alert>
        </div>

        <div *ngIf="needRetentionForGFSAlert"
             class="d-flex align-items-center m-0 mt-4"
             [id]="elementSelectors.id.needRetentionForGFSAlert">
          <mbs-alert class="mb-0"
                     [type]="mbsPopupType.danger"
                     [icon]="true">
            {{ 'wizards:retention.advancedSchedule.needRetentionForGFSAlert' | i18next }}
          </mbs-alert>
        </div>
      </ng-template>
    </mbs-form-group>
  </div>
</div>
